import { Button, Grid, Typography, useTheme } from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Div, DivHor } from "../../components/base/Divs";
import InfoButton from "../../components/base/InfoButton";
import TopBar from "../../components/common/TopBar";
import { AuthContext } from "../../context/AuthContext";
import { post } from "../../network";
import { shadow } from "../../shadows";
import { EVSE, Location } from "../../typings";
import ChoosePMModal from "../misc/ChoosePMModal";
import DisclaimerText from "./components/DisclaimerText";
import LargeDetail from "./components/LargeDetail";
import SmallDetail from "./components/SmallDetail";
import StatusText from "./components/StatusText";

type P = {
    location: Location;
    evse: EVSE;
    cards: any[];
    load: Function;
    error: Function;
    ok: Function;
};

export default function PreChargingScreen({
    location,
    evse,
    cards,
    load,
    error,
    ok
}: P) {
    const history = useHistory();
    const pathname = useLocation().pathname;
    const [showPMID, setShowPMID] = useState(false)
    const [pmid, setPmid] = useState('')
    const theme = useTheme()

    const providerName = location.onNetwork ? 'Public' : location.provider?.name
    const providerImage = location.onNetwork ? '/images/public-charger-icon.png' : location.provider?.imageURL

    const next = () => {
        const options = {};
        if (pmid) {
            options["paymentMethodID"] = pmid;
        } else if (cards?.length > 0) {
            options["paymentMethodID"] = cards?.[0]?._id;
        } else {
            console.error("no payment methods set up with this account");
            alert("no payment method has been setup with this account");
            return;
        }
        load()
        post(
            `transactions/start/${location.postalCode}/${evse.evseID}`,
            options
        ).then((res) => {
            if (res.ok) {
                ok()
            } else {
                error()
                res.text().then((t) => console.error(t));
            }
        });
    };

    const { loggedIn } = useContext(AuthContext);

    return (
        <>
            <TopBar showMap />
            <Div
                style={{
                    paddingTop: 14,
                    backgroundColor: theme.palette.background.default,
                    overflowY: 'auto',
                    paddingBottom: !loggedIn ? '20%' : '0px',
                    justifyContent: "flex-start"
                }}
            >
                <Div>
                    <Typography
                        style={{ color: theme.palette.primary.main, fontWeight: "bold" }}
                    >
                        CHARGER BY
                    </Typography>
                    <img
                        src={providerImage}
                        style={{
                            width: 64,
                            height: 64,
                            borderRadius: 180,
                            objectFit: "cover",
                            margin: "14px 0px",
                            borderColor: "white",
                            borderWidth: 8,
                            borderStyle: "solid",
                            ...shadow,
                        }}
                        alt="Charger Provider"
                    />
                    <InfoButton />

                    <DivHor>
                        <SmallDetail title="Location" text={location.name} />
                        <SmallDetail title="ChargerID" text={evse.evseID} />
                    </DivHor>
                    <DivHor
                        style={{
                            borderTopWidth: 1,
                            borderTopColor: "lightgray",
                            borderTopStyle: "solid",
                        }}
                    >
                        <Div>
                            <LargeDetail
                                title="Max Power"
                                text={evse.maxElectricPower?.toString() || "22"}
                                suffix="kW"
                            />
                        </Div>
                        <span
                            style={{
                                borderRightWidth: 1,
                                borderRightColor: "lightgray",
                                borderRightStyle: "solid",
                                alignSelf: "stretch",
                            }}
                        />
                        <Div>
                            <LargeDetail
                                title="Cost Per kWh"
                                text={evse.chargingRateKWH.toFixed(2)}
                                prefix="$"
                            />
                        </Div>
                    </DivHor>
                </Div>

                {loggedIn ? (
                    <Div>
                        <StatusText text="Charger connected" />
                        <Button
                            variant="contained"
                            style={{ margin: "14px 0px" }}
                            onClick={() => setShowPMID(true)}
                        >
                            Next
                        </Button>
                        <DisclaimerText text="By clicking Next, you agree to our Terms & Conditions" />
                    </Div>
                ) : (
                    <Div
                        style={{
                            backgroundColor: "#83CEC7",
                            borderTopLeftRadius: 32,
                            borderTopRightRadius: 32,
                            position: "fixed",
                            bottom: 0,
                            left: 0,
                            right: 0,
                        }}
                    >
                        <Typography style={{ color: "#48466D" }}>
                            Ready to charge your EV?
                        </Typography>
                        <Button
                            variant="contained"
                            style={{ margin: "14px 0px" }}
                            onClick={() =>
                                history.push(`/register?next=${pathname}`)
                            }
                        >
                            Register Now
                        </Button>
                        <Typography style={{ color: "#48466D" }}>OR</Typography>
                        <Button
                            variant="contained"
                            style={{
                                margin: "14px 0px",
                                color: "#058B8E",
                                backgroundColor: "white",
                            }}
                            onClick={() =>
                                history.push(`/login?next=${pathname}`)
                            }
                        >
                            Log In
                        </Button>
                    </Div>
                )}
            </Div>
            {showPMID && <ChoosePMModal setPMID={(_pmid) => {
                setPmid(_pmid)
                setShowPMID(false)
                next()
            }} />}
        </>
    );
}
